import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { areaManagersQueryOptions } from '@/features/users/api/users.api';
import { getFilterPanelProps } from '@/hooks/useUrlSyncedFilters';
import {
  getActiveStatusFilterField,
  getDateFromToFilterFields,
  getReportingMemberFilterField,
} from '@/utils/filterFields';
import type { useReportingPeriodFilters } from '../hooks/useReportingPeriodFilters';
import { REPORTING_MEMBER_FILTER_KEY } from '../utils/reportingPeriodFilters';

interface ReportingPeriodFilterPanelProps {
  controller: ReturnType<typeof useReportingPeriodFilters>;
}

export function ReportingPeriodFilterPanel({ controller }: ReportingPeriodFilterPanelProps) {
  const { data: reportingMembers } = useQuery(areaManagersQueryOptions());

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields(),
        getActiveStatusFilterField(),
        getReportingMemberFilterField(reportingMembers, REPORTING_MEMBER_FILTER_KEY),
      ]}
      {...getFilterPanelProps(controller)}
    />
  );
}
